import React from "react";
import "./DownloadList.scss";

function DownloadList({
  onDownloadPlain,
  onDownloadWithDescriptions,
  onCancel,
}) {
  return (
    <div className="download-list-content">
      <div className="title">
        <span>Download List as PDF</span>
        <button className="close-button" onClick={onCancel}>
          <span className="material-symbols-outlined">close</span>
        </button>
      </div>

      <div className="download-options">
        <button className="download-option-btn" onClick={onDownloadPlain}>
          <span className="material-symbols-outlined">description</span>
          <div className="option-text">
            <span className="option-title">Download plain list</span>
            <span className="option-description">
              Items only, no descriptions
            </span>
          </div>
        </button>

        <button
          className="download-option-btn"
          onClick={onDownloadWithDescriptions}
        >
          <span className="material-symbols-outlined">article</span>
          <div className="option-text">
            <span className="option-title">
              Download list with descriptions
            </span>
            <span className="option-description">
              Items with full descriptions
            </span>
          </div>
        </button>
      </div>
    </div>
  );
}

export default DownloadList;
